import { Text } from "@aws-amplify/ui-react"
import styled from "styled-components" 

// A = prefix for Aere
// "Libre Caslon Display, Caslon, Serif";
export const AH2 = styled(Text)`
    font-family: "Helvetica Neue", Helvetica, Arial, sans-sefif;
    x-letter-spacing: -2px;
    color: black;
    font-size:2.0rem;
    font-weight:500;
    line-height:1.1;
`

export const AH4 = styled(Text)`
    font-family: "Helvetica Neue", Helvetica, Arial, sans-sefif;
    color: black;
    font-size:1.4rem;
    line-height:1.1;
`